import React from 'react';
import { Keyboard, X } from 'lucide-react';

const shortcuts = [
  { keys: ['Ctrl', 'Enter'], action: 'Generate Docs' },
  { keys: ['Ctrl', 'Shift', 'C'], action: 'Copy All' },
  { keys: ['Ctrl', 'Shift', 'N'], action: 'Next Patient' },
  { keys: ['Ctrl', 'Shift', 'M'], action: 'Minimalist View (Calm-Mode)' },
  { keys: ['Ctrl', '/'], action: 'Toggle This Panel' },
];

const KeyBadge = ({ children }) => (
  <kbd className="inline-flex items-center justify-center min-w-[24px] h-6 px-1.5 text-[11px] font-mono font-semibold bg-secondary border border-border rounded text-muted-foreground">
    {children}
  </kbd>
);

const ShortcutLegend = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed bottom-4 right-4 z-50 w-64 bg-card border border-border rounded-xl shadow-2xl overflow-hidden animate-in slide-in-from-bottom-4 duration-200"
      data-testid="shortcut-legend"
    >
      <div className="flex items-center justify-between px-3 py-2 border-b border-border bg-secondary/30">
        <div className="flex items-center gap-2">
          <Keyboard className="w-4 h-4 text-primary" />
          <span className="text-xs font-semibold text-foreground">Keyboard Shortcuts</span>
        </div>
        <button onClick={onClose} className="p-0.5 hover:bg-secondary rounded" data-testid="close-shortcut-legend">
          <X className="w-3.5 h-3.5 text-muted-foreground" />
        </button>
      </div>
      <div className="p-2 space-y-1">
        {shortcuts.map((s, i) => (
          <div key={i} className="flex items-center justify-between py-1.5 px-1">
            <span className="text-xs text-muted-foreground">{s.action}</span>
            <div className="flex items-center gap-1">
              {s.keys.map((k, j) => (
                <React.Fragment key={j}>
                  {j > 0 && <span className="text-[10px] text-muted-foreground/50">+</span>}
                  <KeyBadge>{k}</KeyBadge>
                </React.Fragment>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShortcutLegend;
